import React, { ReactElement } from "react";
import { X } from "lucide-react";

interface IPanel {
    title?: string;
    children?: any;
    isOpen?: boolean;
    onDismiss: () => void;
    width?: number | string;
}

export const Panel = ({ title, children, isOpen, onDismiss, width = 320 }: IPanel): ReactElement => {
    const panelWidth = typeof width === "number" ? `${width}px` : width;

    return isOpen ? (
        <div
            role="dialog"
            className="panel fixed top-0 bottom-0 right-0 z-[1000] flex flex-col overflow-hidden bg-white shadow-[0px_25.6px_57.6px_0px_#00000038,0px_4.8px_14.4px_0px_#0000002e]"
            style={{ width: panelWidth, maxWidth: panelWidth }}
        >
            <header className="relative flex min-h-[60px] w-full flex-col px-5 pt-[30px]">
                <h2 className="m-0 p-0 text-lg font-medium leading-normal">{title}</h2>
                <button
                    id="close"
                    type="button"
                    className="close absolute right-5 top-5 inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded border-0 bg-transparent p-0 transition-colors hover:bg-black/5"
                    onClick={() => onDismiss()}
                    aria-label="Close panel"
                >
                    <X size={20} />
                </button>
            </header>
            <div className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto p-5">{children}</div>
        </div>
    ) : null;
};
